document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-date-picker]').forEach(i => {

        let monthsToDisplay = (queryViewport() === "xs" || queryViewport() === "sm") ? 1 : 2;

        flatpickr(i, {
            showMonths: monthsToDisplay,
            minDate: "today",
            dateFormat: "d-m-Y",
            static: true,
            monthSelectorType: 'static',
            "locale": {
                "firstDayOfWeek": 1
            }
        });
    });

    document.querySelectorAll('[data-time-picker]').forEach(i => {
        flatpickr(i, {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true
        });
    });

})